import { useEffect } from 'react';
import { Hero } from 'components/Hero';
import { Footer } from 'components/Footer';
import { Bar } from 'components/Header/Bar';
import { DaysCountCard } from 'components/Cards/DaysCountCard';
import { DollarCountCard } from 'components/Cards/DollarCountCard';
import { RecipientSpotlightCard } from 'components/Cards/RecipientSpotlightCard';
import { trackPixel } from 'helpers/pixel';
import { trackEvent } from 'helpers/mixpanelEvents';
import { useAppSelector } from 'helpers/hooks';
import { getLandingTopAndImpactConfig } from 'selectors/siteConfig';
import { PressSection } from './PressSection';
import { TrendingSection } from './TrendingSection';
import { LearnMoreSection } from './LearnMoreSection';
import { PoweredBySection } from './PoweredBySection';
import { GetStartedSection } from './GetStartedSection';
import { GiveBySelectorSection } from './GiveBySelectorSection';
import { GetRecommendations } from './GetRecommendations';
import { ImpactReportSection } from './ImpactReportSection';
import { Container, Content } from './styled';

const redirectToDonateIfNeeded = (currentUrl: string) => {
  const url = new URL(currentUrl);
  const searchParams = url.searchParams;

  if (searchParams.has('tags') || searchParams.has('p')) {
    window.location.href = `/donate?${searchParams.toString()}`;
  }
  return;
};

export const LandingScreen = () => {
  redirectToDonateIfNeeded(window.location.href);
  const {
    landingTopCardConfig,
    landingImpactConfig,
    landingRecipientSpotlightConfig,
    giveByConfig,
  } = useAppSelector(getLandingTopAndImpactConfig);

  useEffect(() => {
    trackPixel('universalPixel');
  }, []);

  const handleRecipientSpotlightViewed = (linkUrl: string) =>
    trackEvent('Landing Page Recipient Spotlight Viewed', { link_url: linkUrl });

  const handleElectionCountdownViewed = (linkUrl: string) =>
    trackEvent('Landing Page Election Countdown Viewed', { link_url: linkUrl });

  const handleRecipientSpotlightDonateClick = (linkUrl: string) =>
    trackEvent('Landing Page Recipient Spotlight Donate Link Clicked', { link_url: linkUrl });

  const handleElectionCountdownDonateClick = (linkUrl: string) =>
    trackEvent('Landing Page Election Countdown Donate Link Clicked', { link_url: linkUrl });

  return (
    <Container>
      <Bar />
      <Content>
        <Hero
          title="The smartest way to do your political giving."
          subtitle="Oath empowers donors to give more strategically by making data-driven recommendations about where your dollars have maximum impact."
          ctaText="Sign up now"
          cta="#footer-signup"
        >
          {landingTopCardConfig?.top_card_config === 'countdown-close-the-gap' ? (
            <DollarCountCard />
          ) : landingTopCardConfig?.top_card_config === 'countdown-days-until-election' ? (
            <DaysCountCard
              date={landingTopCardConfig?.election_date}
              onDonateClick={handleElectionCountdownDonateClick}
              onView={handleElectionCountdownViewed}
            />
          ) : (
            landingTopCardConfig?.top_card_config === 'recipient-spotlight' &&
            !!landingRecipientSpotlightConfig?.cards?.length && (
              <RecipientSpotlightCard
                config={landingRecipientSpotlightConfig}
                onDonateClick={handleRecipientSpotlightDonateClick}
                onView={handleRecipientSpotlightViewed}
              />
            )
          )}
        </Hero>
        <PressSection />
        {landingImpactConfig?.impact_card_config === 'on' && (
          <ImpactReportSection period={landingImpactConfig?.period} />
        )}
        <GetStartedSection />
        <GiveBySelectorSection giveByConfig={giveByConfig} />
        {landingImpactConfig?.impact_card_config !== 'on' && <TrendingSection />}
        <GetRecommendations />
        <LearnMoreSection />
        <PoweredBySection />
      </Content>
      <Footer />
    </Container>
  );
};
